import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { Location } from '@angular/common';
import { DataService } from 'src/app/Service/data.service';
import { PersianNumberService } from 'ngx-persian';
import { defaults as defaultControls, FullScreen } from 'ol/control';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { BingMaps, XYZ } from 'ol/source';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;


@Component({
  selector: 'stopMap',
  templateUrl: './stopMap.component.html',
  styleUrls: ['./stopMap.component.css'],
})

export class StopMapComponent implements OnInit {
  map: any = {};
  Id: any = 0;
  stime: any = '';
  etime: any = '';
  dataAz: any = '';
  dataTa: any = '';
  reportData: any;
  polyganData: any;
  polyganId: any;
  refuelingReport: any;
  mapSatelait: boolean = false;
  layers: any = [];
  source: any;
  vector: any;
    private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private mapService: MapService,
    private route: ActivatedRoute,
    private _location: Location,
    private dataService: DataService,
    private persianNumberService: PersianNumberService,
    private gurdService: GurdServiceService

  ) { }
  ngOnInit(): void {
    this.stime = this.gurdService.decrypt(window.localStorage.getItem("reportStime")!);
    this.etime = this.gurdService.decrypt(window.localStorage.getItem("reportEtime")!);
    this.dataAz = this.gurdService.decrypt(window.localStorage.getItem("reportDataZa")!);
    this.dataTa = this.gurdService.decrypt(window.localStorage.getItem("reportDataTa")!);
    setTimeout(() => {
      this.newOpenMap();
      this.route.params.subscribe(params => {

        this.Id = params['id'];

        this.polyganId = params['polygan'];

        if (this.Id != undefined) {

          if (this.Id.includes('$')) this.getStop();

          else if (this.Id.includes('|')) this.getStop_2()

          else if (this.Id.includes('=')) this.getStop_3()

          else if (this.Id.includes('&')) this.getTankerData()

          else if (this.Id.includes('*')) this.getJournal();

          else if (this.Id.includes('-')) this.getDeviceEvent();

          else if (this.Id.includes('_')) this.getGPSIO();

          else if (this.Id.includes('!')) this.getArea();

          else if (this.Id.includes('÷')) this.getRefuelingReport();

          else this.getCar();

        }

        else this.getCar();

      })

    }, 1000);

    setTimeout(() => {
      this.map.on('pointermove', (evt: any) => {
        if (!evt.dragging) {
          this.map.getTargetElement().style.cursor = this.map.hasFeatureAtPixel(this.map.getEventPixel(evt.originalEvent)) ? 'pointer' : '';
        }
      })

      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }
        setTimeout(() => {
          var el = this.mapService.mapPointerMove(
            this.map.getEventPixel(e.originalEvent),
            this.map
          );
          this.showData(el);
        }, 50);
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 1500);

  }

  changeTail() {

    if (this.mapSatelait == false) {

      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);
    }

    else {

      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);

    }

    this.mapSatelait = !this.mapSatelait;
  }

  // newOpenMap() {
  //   this.map = new Map({
  //     interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
  //     target: 'test',
  //     layers: [
  //       new TileLayer({
  //         source: new OSM({}),
  //       }),
  //     ],
  //     view: new View({
  //       center: olProj.fromLonLat([51.3833554, 35.6770113]),
  //       zoom: 12,
  //     }),
  //   });

  //   //context menu
  // }

  newOpenMap() {
    this.source = new VectorSource({ wrapX: false });
    this.vector = new VectorLayer({
      source: this.source,
    });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }
    this.map = new Map({
      controls: defaultControls().extend([new FullScreen()]),
      layers: this.layers,
      target: 'test',
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: 13,
      }),
    });

  }

  private buildTooltipHtml(
    title: string,
    subTitle: string,
    rows: { label: string, value: any, icon: string, block?: boolean }[],
  ) {
    const body = rows
      .filter((row) => row.value !== undefined && row.value !== null && row.value !== '')
      .map(
        (row) => `
                    <div class="mk-tooltip__row${row.block ? ' mk-tooltip__row--block' : ''}">
                        <span class="mk-tooltip__lbl"><i class="fa ${row.icon}"></i>${row.label}</span>
                        <span class="mk-tooltip__val">${row.value}</span>
                    </div>`,
      )
      .join('');

    return `<div class="mk-tooltip">
                <div class="mk-tooltip__head">
                    <div class="mk-tooltip__title">
                        <div class="mk-tooltip__name">${title || 'نامشخص'}</div>
                        <div class="mk-tooltip__type">${subTitle || ''}</div>
                    </div>
                </div>
                <div class="mk-tooltip__body">
                    ${body}
                </div>
            </div>`;
  }

  getCar = async () => {
    var fLat = this.gurdService.decrypt(window.localStorage.getItem("fLat")!);
    var fLon = this.gurdService.decrypt(window.localStorage.getItem("fLon")!);
    if (this.Id == "1") {
      const comment = this.gurdService.decrypt(window.localStorage.getItem("commentJournal")!);
      const date = this.gurdService.decrypt(window.localStorage.getItem("dateJournal")!);
      const time = this.gurdService.decrypt(window.localStorage.getItem("timeJournal")!);

      var marker = this.mapService.createMarker(
        [fLon, fLat],
        '../../assets/Img/marker5.png',
        `${1}`,
        ``,
        {
          html: this.buildTooltipHtml(comment, 'یادداشت', [
            { label: 'تاریخ', value: date, icon: 'fa-calendar' },
            { label: 'زمان', value: time, icon: 'fa-clock-o' },
          ]),
        }
      );
    }
    else if (this.Id == "2") {
      const comment = this.gurdService.decrypt(window.localStorage.getItem("commentJournal")!);
      const fule = this.gurdService.decrypt(window.localStorage.getItem("fule")!);
      const km = this.gurdService.decrypt(window.localStorage.getItem("IDefKM")!);
      const date = this.gurdService.decrypt(window.localStorage.getItem("dateJournal")!);
      const time = this.gurdService.decrypt(window.localStorage.getItem("timeJournal")!);

      var marker = this.mapService.createMarker(
        [fLon, fLat],
        '../../assets/Img/gasStation.png',
        `${1}`,
        ``,
        {
          html: this.buildTooltipHtml(comment, 'سوخت گیری', [
            { label: 'سوخت مصرفی', value: fule, icon: 'fa-tint' },
            { label: 'کیلومتر طی شده', value: km, icon: 'fa-tachometer' },
            { label: 'تاریخ', value: date, icon: 'fa-calendar' },
            { label: 'زمان', value: time, icon: 'fa-clock-o' },
          ]),
        }
      );
    }
    else {
      var model = JSON.parse(this.gurdService.decrypt(window.localStorage.getItem("StopModel")!));

      const html = model.strParkTime
        ? this.buildTooltipHtml(
          this.gurdService.decrypt(window.localStorage.getItem("carName")!),
          'توقف',
          [
            { label: 'تاریخ', value: model.strDate, icon: 'fa-calendar' },
            { label: 'زمان', value: `${model.strSTime}-${model.strETime}`, icon: 'fa-clock-o' },
            { label: 'مدت توقف', value: model.strParkTime, icon: 'fa-hourglass-half' },
            { label: 'آدرس', value: model.strAddress, icon: 'fa-map-marker', block: true },
          ],
        )
        : this.buildTooltipHtml(
          this.gurdService.decrypt(window.localStorage.getItem("nameOfDriv")!),
          'موقعیت متحرک',
          [
            {
              label: 'تاریخ',
              value: this.persianNumberService.toPersian(model.strDate),
              icon: 'fa-calendar',
            },
          ],
        );

      var marker = this.mapService.createMarker(
        [fLon, fLat],
        '../../assets/Img/marker5.png',
        `${1}`,
        ``,
        {
          html: html,
        }
      );

    }

    this.map.addLayer(marker);
    this.fitMap(fLat, fLon);

  };

  fitMap(fLat: any, fLon: any) {

    var maxLatitude = fLat

    var maxLongitude = fLon;

    var minLatitude = fLat;
    var minLongitude = fLon;

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([
      maxLongitude,
      maxLatitude,
    ]);
    var transformedEnd = this.mapService.transformCoordinates2([
      minLongitude,
      minLatitude,
    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
      // Math.min(transformedStart[0], transformedEnd[0]) - 2000,
      // Math.min(transformedStart[1], transformedEnd[1]) - 2000,
      // Math.max(transformedStart[0], transformedEnd[0]) + 2000,
      // Math.max(transformedStart[1], transformedEnd[1] + 2000)
    ];
    view.fit(source);

  }

  showData(item: any) {
    var tooltip = $('#map_tooltip');
    const html = item?.featureLayer?.feature?.get('data')?.html ?? '';

    tooltip.tooltip('dispose');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
      template:
        '<div class="tooltip mk-tip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner mk-tip-inner"></div></div>',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        tooltip
          .attr(
            'data-bs-original-title',
            html
          )
          .tooltip('show');
      }
    } else {
      tooltip.tooltip('hide');
    }
  }

  goBack() {
    this._location.back();
  }

  getStop = async () => {
    this.Id = this.Id.split("$");

    const carName = this.gurdService.decrypt(window.localStorage.getItem("carName")!);

    const buildStopHtml = (item: any) =>
      this.buildTooltipHtml(carName, 'توقف', [
        { label: 'تاریخ', value: item.strDate, icon: 'fa-calendar' },
        { label: 'زمان', value: `${item.strSTime}-${item.strETime}`, icon: 'fa-clock-o' },
        { label: 'مدت توقف', value: item.strParkTime, icon: 'fa-hourglass-half' },
        { label: 'آدرس', value: item.strAddress, icon: 'fa-map-marker', block: true },
      ]);

    if (!this.dataService.stopData) {

      this.dataService.getStop(this.Id[0]).then((resp: any) => {
        this.reportData = this.dataService.stopData;
        for (let index = 0; index < this.reportData.length; index++) {
          var marker = this.mapService.createMarker(
            [this.reportData[index].fLon, this.reportData[index].fLat],
            '../../assets/Img/marker5.png',
            `${1}`,
            ``,
            {
              html: buildStopHtml(this.reportData[index]),
            }
          );
          this.map.addLayer(marker);

        }
        this.fitMapArray(this.reportData);
      });
    }
    else {

      // console.log(this.reportData)
      this.reportData = this.dataService.stopData;
      for (let index = 0; index < this.reportData.length; index++) {
        var marker = this.mapService.createMarker(
          [this.reportData[index].fLon, this.reportData[index].fLat],
          '../../assets/Img/marker5.png',
          `${1}`,
          ``,
          {
            html: buildStopHtml(this.reportData[index]),
          }
        );
        this.map.addLayer(marker);

      }
      this.fitMapArray(this.reportData);
    }


  }

  getStop_2 = async () => {

    this.Id = this.Id.split("|");

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strUnitID: this.Id[0],

      strSDate: this.gurdService.decrypt(window.localStorage.getItem('reportDataZa')!),

      strEDate: this.gurdService.decrypt(window.localStorage.getItem('reportDataTa')!)

    }

    this.otherService.Showspinner()

    const resp = await axios.post('Fueltank_Refueling', model);

    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);

    for (let index = 0; index < this.reportData.length; index++) {

      var marker = this.mapService.createMarker(

        [this.reportData[index].fLon, this.reportData[index].fLat],

        '../../assets/Img/marker5.png',

        `${1}`,

        ``,

        {
          html: this.buildTooltipHtml(this.reportData[index].strFullName, 'سوخت‌گیری مخزن', [
            { label: 'تاریخ', value: this.reportData[index].strDateTime, icon: 'fa-calendar' },
            { label: 'مقدار', value: this.reportData[index].fValue, icon: 'fa-tint' },
            { label: 'آدرس', value: this.reportData[index].strAddress, icon: 'fa-map-marker', block: true },
          ]),

        }

      );

      this.map.addLayer(marker);

    }

    this.fitMapArray(this.reportData);

  }

  getStop_3 = async () => {

    this.Id = this.Id.split("=");

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strUnitID: this.Id[0],

      strSDate: this.gurdService.decrypt(window.localStorage.getItem('reportDataZa')!),

      strEDate: this.gurdService.decrypt(window.localStorage.getItem('reportDataTa')!)

    }

    this.otherService.Showspinner()

    const resp = await axios.post('Fueltank_SuspiciousDischarge', model);

    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);

    for (let index = 0; index < this.reportData.length; index++) {

      var marker = this.mapService.createMarker(

        [this.reportData[index].fLon, this.reportData[index].fLat],

        '../../assets/Img/marker5.png',

        `${1}`,

        ``,

        {
          html: this.buildTooltipHtml(this.reportData[index].strFullName, 'تخلیه مشکوک', [
            { label: 'تاریخ', value: this.reportData[index].strDateTime, icon: 'fa-calendar' },
            { label: 'مقدار', value: this.reportData[index].fValue, icon: 'fa-tint' },
            { label: 'آدرس', value: this.reportData[index].strAddress, icon: 'fa-map-marker', block: true },
          ]),

        }

      );

      this.map.addLayer(marker);

    }

    this.fitMapArray(this.reportData);

  }

  getTankerData = async () => {

    this.Id = this.Id.split("&");

    let api = this.Id[1] == "_" ? 'Tanker_Report_Feeding_Statistics4One' : 'Tanker_Report_Discharge'

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strUnitID: this.Id[0],

      strSDate: this.gurdService.decrypt(window.localStorage.getItem('reportDataZa')!),

      strEDate: this.gurdService.decrypt(window.localStorage.getItem('reportDataTa')!)

    }

    this.otherService.Showspinner()

    const resp = await axios.post(api, model);

    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);

    for (let index = 0; index < this.reportData.length; index++) {

      var marker = this.mapService.createMarker(

        [this.reportData[index].fLon, this.reportData[index].fLat],

        '../../assets/Img/marker5.png',

        `${1}`,

        ``,

        {
          html: this.Id[1] != "_"
            ? this.buildTooltipHtml(
              this.gurdService.decrypt(window.localStorage.getItem("carName")!),
              'تخلیه تانکر',
              [
                { label: 'تاریخ', value: this.reportData[index].strDate, icon: 'fa-calendar' },
                { label: 'زمان', value: `${this.reportData[index].strSTime} - ${this.reportData[index].strETime}`, icon: 'fa-clock-o' },
                { label: 'حجم', value: `${this.reportData[index].fDischargeValue} لیتر`, icon: 'fa-tint' },
                { label: 'سرعت', value: this.reportData[index].iSpeed, icon: 'fa-tachometer' },
                { label: 'آدرس', value: this.reportData[index].strAddress, icon: 'fa-map-marker', block: true },
              ],
            )
            : this.buildTooltipHtml(
              this.gurdService.decrypt(window.localStorage.getItem("carName")!),
              'تغذیه تانکر',
              [
                { label: 'محل تامین', value: this.reportData[index].strTitle, icon: 'fa-map-marker' },
                { label: 'حجم کل تغذیه', value: `${this.reportData[index].fFeedingValue} لیتر`, icon: 'fa-tint' },
                { label: 'تعداد تغذیه', value: this.reportData[index].iCount, icon: 'fa-hashtag' },
              ],
            ),
        }

      );

      this.map.addLayer(marker);

    }

    this.fitMapArray(this.reportData);

  }

  getJournal = async () => {
    this.otherService.Showspinner();
    this.Id = this.Id.split("*");
    var model = {
      strSDate: this.dataAz,
      strUnitID: this.Id[0],
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };
    const resp = await axios.post(
      `GetAllJournal`, model);
    this.otherService.nonespinner();

    this.reportData = resp.data;

    for (let index = 0; index < this.reportData.length; index++) {
      var marker = this.mapService.createMarker(
        [this.reportData[index].fLon, this.reportData[index].fLat],
        '../../assets/Img/marker5.png',
        `${1}`,
        ``,
        {
          html: this.buildTooltipHtml(this.reportData[index].strComment, 'یادداشت', [
            { label: 'تاریخ', value: this.reportData[index].strDate, icon: 'fa-calendar' },
            { label: 'زمان', value: this.reportData[index].strTime, icon: 'fa-clock-o' },
          ]),
        }
      );
      this.map.addLayer(marker);

    }
    this.fitMapArray(this.reportData);

  }

  getDeviceEvent = async () => {
    this.otherService.Showspinner();
    this.Id = this.Id.split("-");
    var model = {
      strSDate: this.dataAz,
      strUnitID: this.Id[0],
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      tiDeviceEventsType: this.gurdService.decrypt(window.localStorage.getItem('deviceEvents')!),
    };

    const resp = await axios.post(
      `Report_DeviceEvents`, model);
    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);
    for (let index = 0; index < this.reportData.length; index++) {
      var marker = this.mapService.createMarker(
        [this.reportData[index].fLon, this.reportData[index].fLat],
        '../../assets/Img/marker5.png',
        `${1}`,
        ``,
        {
          html: this.buildTooltipHtml(
            this.reportData[index].strDeviceEventsType_strComment,
            'رویداد دستگاه',
            [
              { label: 'تاریخ', value: this.reportData[index].strDate, icon: 'fa-calendar' },
              { label: 'زمان', value: this.reportData[index].strTime, icon: 'fa-clock-o' },
            ],
          ),
        }
      );
      this.map.addLayer(marker);

    }
    this.fitMapArray(this.reportData);

  }

  getGPSIO = async () => {
    //this.otherService.Showspinner();
    this.Id = this.Id.split("_");
    var model = {
      strSDate: this.dataAz,
      strUnitID: this.Id[0],
      strEDate: this.dataTa,
      iSystemUser: window.localStorage.getItem('ID'),
    };

    // const resp = await axios.post(
    //   `Report_GPSIO`, model);
    // this.otherService.nonespinner();
    if (!this.dataService.gpsIoData) {
      this.dataService.getGpsIo(model).then((resp: any) => {

        this.reportData = this.dataService.gpsIoData;
        for (let index = 0; index < this.reportData.length; index++) {
          var marker = this.mapService.createMarker(
            [this.reportData[index].fLon, this.reportData[index].fLat],
            '../../assets/Img/marker5.png',
            `${1}`,
            ``,
            {
              html: this.buildTooltipHtml(this.reportData[index].strIOName, 'ورودی/خروجی', [
                { label: 'تاریخ', value: this.reportData[index].strDate, icon: 'fa-calendar' },
                { label: 'زمان', value: this.reportData[index].strTime, icon: 'fa-clock-o' },
              ]),
            }
          );
          this.map.addLayer(marker);

        }
        this.fitMapArray(this.reportData);
      });
    }
    else {
      this.reportData = this.dataService.gpsIoData;

      for (let index = 0; index < this.reportData.length; index++) {
        var marker = this.mapService.createMarker(
          [this.reportData[index].fLon, this.reportData[index].fLat],
          '../../assets/Img/marker5.png',
          `${1}`,
          ``,
          {
            html: this.buildTooltipHtml(this.reportData[index].strIOName, 'ورودی/خروجی', [
              { label: 'تاریخ', value: this.reportData[index].strDate, icon: 'fa-calendar' },
              { label: 'زمان', value: this.reportData[index].strTime, icon: 'fa-clock-o' },
            ]),
          }
        );
        this.map.addLayer(marker);

      }
      this.fitMapArray(this.reportData);
    }



  }

  getArea = async () => {
    if (this.polyganId) {
      this.polyganData = this.mapService.drawPolygan(this.map, this.polyganId, this.polyganData);
    }
    this.otherService.Showspinner();
    this.Id = this.Id.split("!");
    var model = {

      iArrivalsAndDepartures: this.Id[0],
      strSession: `${this.gurdService.decrypt(window.localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };

    const resp = await axios.post(
      `GetInOutAttendanceDriver`, model);
    this.otherService.nonespinner();
    this.reportData = JSON.parse(resp.data);
    for (let index = 0; index < this.reportData.length; index++) {
      var markerStrat = this.mapService.createMarker(
        [this.reportData[index].fLon, this.reportData[index].fLat],
        '../../assets/Img/marker5.png',
        `${index}`,
        ``,
        {
          html: this.buildTooltipHtml(this.reportData[index].strFullName, 'ورود به منطقه', [
            { label: 'زمان ورود', value: this.reportData[index].strPresenceTime, icon: 'fa-sign-in' },
            { label: 'منطقه', value: this.reportData[index].strTitle, icon: 'fa-map-marker' },
          ]),

        }
      );
      this.map.addLayer(markerStrat);
      var markerEnd = this.mapService.createMarker(
        [this.reportData[index].fDeparturesLon, this.reportData[index].fDeparturesLat],
        '../../assets/Img/marker4.png',
        `${index + "$"}`,
        ``,
        {
          html: this.buildTooltipHtml(this.reportData[index].strFullName, 'خروج از منطقه', [
            { label: 'زمان خروج', value: this.reportData[index].strExitTime, icon: 'fa-sign-out' },
            { label: 'منطقه', value: this.reportData[index].strTitle, icon: 'fa-map-marker' },
          ]),
        }
      );
      this.map.addLayer(markerEnd);

    }
    if (!this.polyganId) {
      this.fitMapArray(this.reportData);
    }

  }

  ngOnDestroy(): void {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');

  }

  fitMapArray(data: any) {

    //remove car not have Location
    data = data.filter(function (el: any) {
      return el.fLon != 0;
    });

    var maxLatitude = Math.max.apply(
      Math,
      data.map(function (o: any) {
        return o.fLat;
      })
    );
    var maxLongitude = Math.max.apply(
      Math,
      data.map(function (o: any) {
        return o.fLon;
      })
    );
    var minLatitude = Math.min.apply(
      Math,
      data.map(function (o: any) {
        return o.fLat;
      })
    );
    var minLongitude = Math.min.apply(
      Math,
      data.map(function (o: any) {
        return o.fLon;
      })
    );

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([
      maxLongitude,
      maxLatitude,
    ]);
    var transformedEnd = this.mapService.transformCoordinates2([
      minLongitude,
      minLatitude,
    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 6000,
      Math.min(transformedStart[1], transformedEnd[1]) - 6000,
      Math.max(transformedStart[0], transformedEnd[0]) + 6000,
      Math.max(transformedStart[1], transformedEnd[1]) + 6000,

    ];
    view.fit(source);
    if (data.length == 1) {
      this.map.getView().setZoom(17);
    }

  }

  getRefuelingReport = async () => {
    //     var model = {
    //       strUnitID: this.Id,
    //       strSDate: this.dataAz,
    //       strEDate: this.dataTa,
    //       iSystemUser: window.localStorage.getItem('ID'),
    //       strSession: window.localStorage.getItem('Session'),
    //     };
    //     const resp = await axios.post("FuelReport_ReportMobile", model);
    //     this.refuelingReport = JSON.parse(resp.data);
    // this.otherService.Showspinner();
    this.Id = this.Id.split("÷");
    var model = {
      strSDate: this.dataAz,
      strUnitID: this.Id[0],
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    };

    const resp = await axios.post(
      `FuelReport_ReportMobile`, model);
    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);
    for (let index = 0; index < this.reportData.length; index++) {
      var marker = this.mapService.createMarker(
        [this.reportData[index].fLon, this.reportData[index].fLat],
        '../../assets/Img/gasStation.png',
        `${1}`,
        ``,
        {
          html: this.buildTooltipHtml(this.reportData[index].strFullName, 'سوخت‌گیری', [
            { label: 'سوخت مصرفی', value: this.reportData[index].fLiter, icon: 'fa-tint' },
            { label: 'پیمایش نسبت به قبل', value: this.reportData[index].IDefKM, icon: 'fa-tachometer' },
            { label: 'تاریخ', value: this.reportData[index].strDate, icon: 'fa-calendar' },
            { label: 'زمان', value: this.reportData[index].strTime, icon: 'fa-clock-o' },
          ]),
        }
      );
      this.map.addLayer(marker);

    }
    this.fitMapArray(this.reportData);

  }

}
